import { createSelector } from "reselect";

export const getAllRecurringTasks = (state) => state.recurringTasks;

export const getRecurringTaskById = (state, id) => state.recurringTasks[id];

export const getRecurringTasksByProjectId = createSelector(
  getAllRecurringTasks,
  (state, projectId) => projectId,
  (recurringTasks, projectId) => {
    return Object.values(recurringTasks)
      .filter((rt) => {
        return !rt.is_trashed && rt.project_id === projectId;
      })
      .sort((a, b) => a.name.localeCompare(b.name));
  }
);
